import React, { useEffect, useState } from 'react';
import { Link,useLocation } from 'react-router-dom';
import CanTabing from '../../../component/CanTabing';
import Breadcrumb from '../../../component/Breadcrumb';
import PageTabing from '../../../component/PageTabing';
import {Button, Box, Grid, Typography } from '@mui/material';
import RequestPGNRows from './rows';
import swal from 'sweetalert';
import AddNewRequest from './addNew';
import MappingTabing from '../../../component/MappingTabing';
import CanMappingTabing from '../../../component/CanMappingTabing';
import { checklocalStorageItems, saveContentFile } from '../../../utlis';
import Loader from '../../../component/Loader/Loader';

const ECURequestPGN = () => {
    const location = useLocation();
    const [buttonDisable,setButtonDisable]  = useState(true);
    const [rows,setRows]                    = useState({});
    const [editRowIndex,setEditRowIndex]    = useState('');
    const [showLoader, setShowLoader]       = useState(false);
    const [itemForLocal, setItemForLocal]   = useState(false);
    const [fields,setFields] = useState({
        ECMID           : '',
        DestAddrOverd   : '',
        PGN             : '',
        TrigAddr        : '',
        ReTxRate        : '',
        Desc            : '',
    });
    const [showForm, setShowForm] = React.useState(false);


    const handleAddRequest = () => {
        setShowForm(true);
    }

    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        getFetchFieldsData();
    },[]);

    const getFetchFieldsData = () => {
        let existingRequestPGN= JSON.parse(localStorage.getItem('ECURequestPGN'));
        if(existingRequestPGN != null && existingRequestPGN.length > 0){
            setRows(existingRequestPGN);
        }
    }

    const handleRowDelete = (rowIndex) => {
        const newArray = [...rows];
        newArray.splice(rowIndex, 1);
        setRows(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("ECURequestPGN");
        } else {
            localStorage.setItem('ECURequestPGN',JSON.stringify(newArray));
        }
    }

    const handleBlurUpdate = (name,value) => {
        let finalVal;
        if(name === 'ReTxRate') {
            const result = decimalValidation(name,value);
            if(result){
                swal("Oops!", "Please use Float value for ReTxRate!", "error");
            }
            if(value % 1 === 0){
                value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
            }
            finalVal = value ? parseFloat(value) : '';
        } else {
            finalVal = parseInt(value);
        }
        setFields((prevState) => ({...prevState, [name]: finalVal}));
        //setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 

    const changeHandler = (e) => {
        let value = e.target.name === 'ECMID' || e.target.name === 'Desc' ? e.target.value : e.target.value.replace(/\D/g, "");
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: value}))
    }

    const decimalValidation = (name,value) => {
        let validationArray = ['ReTxRate'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }

    const handleSubmit = () => {
        const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(isEmpty){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        let valdationStatus = false;
        Object.keys(fields).forEach(function(key) {
            const result = decimalValidation(key,fields[key]);
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            swal("Oops!", "Please use Float value for ReTxRate!", "error");
            return false;
        }
        if(editRowIndex !== ''){
            let existingRequestPGN = JSON.parse(localStorage.getItem('ECURequestPGN'));
            existingRequestPGN[editRowIndex] = fields;
            localStorage.setItem('ECURequestPGN',JSON.stringify(existingRequestPGN));
            swal({
                title: "Success",
                text: 'ECU Request PGN updated successfully.',
                icon: "success",
            })
        } else {
            let existingRequestPGN = JSON.parse(localStorage.getItem('ECURequestPGN'));
            if(existingRequestPGN == null) existingRequestPGN = [];
            existingRequestPGN.push(fields);
            localStorage.setItem('ECURequestPGN',JSON.stringify(existingRequestPGN));
            swal({
                title: "Success",
                text: 'ECU Request PGN added successfully.',
                icon: "success",
            })
        }
        setFields({
            ECMID           : '',
            DestAddrOverd   : '',
            PGN             : '',
            TrigAddr        : '',
            ReTxRate        : '',
            Desc            : '',
        })
        setShowForm(false);
        setEditRowIndex('');
        getFetchFieldsData();
    }

    useEffect(() => {
        const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(isEmpty){
            setButtonDisable(true);
        } else {
            setButtonDisable(false);
        }
    },[fields]);

    const handleEditRow = (rowDetails, rowIndex) => {
        setFields(rowDetails);
        setEditRowIndex(rowIndex);
        setShowForm(true);
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb  title="ECU Request PGN">
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                CAN
                </Typography>
            </Breadcrumb>
            {location.pathname.includes('mapping') &&
                <MappingTabing 
                    value="can" 
                    handleConfigFileContent={handleConfigFileContent}
                />
            }
            {!location.pathname.includes('mapping') &&
                <PageTabing value="can" />
            }
            <Box  component="section">
                <Grid className="contentBox">
                    {location.pathname.includes('mapping') &&
                        <CanMappingTabing value="request-pgn" />
                    }
                    {!location.pathname.includes('mapping') &&
                        <CanTabing value="request-pgn" />
                    }
                    {(!location.pathname.includes('mapping') || itemForLocal) &&
                    <Grid sx={{pr:'15px !important'}} className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                //component={Link} to="/can/request-pgn/new"
                                onClick={handleAddRequest}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Add Request 
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                disabled={buttonDisable ? true : false}
                                onClick={handleSubmit}
                                variant="contained"
                                size="small"
                                color="secondary"
                            >Submit
                            </Button>
                        </Grid>
                    </Grid>
                    }
                    {showForm &&
                        <AddNewRequest 
                            fields={fields}
                            changeHandler={changeHandler}
                            handleBlurUpdate={handleBlurUpdate}
                        />
                    }
                    {rows?.length === 0  &&
                        <p>No Data Available.</p>
                    }
                    {rows?.length > 0 &&
                        <RequestPGNRows 
                            data={rows}
                            handleRowDelete={handleRowDelete}
                            handleEditRow={handleEditRow}
                        />
                    }
                </Grid>
            </Box>
        </>
    )
};

export default ECURequestPGN;
